export interface GetAnnouncementDto {
    id: string;

    message: Record<string, string>;

    dismissible: boolean;

    startDate: Date;

    endDate: Date;

    linkUrl?: string | undefined;

    linkName?: string | undefined;

    countryISO31661Alpha2Code?: string[] | undefined;
}
